import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MovieCard } from "@/components/MovieCard";
import { Film } from "lucide-react";

const Browse = () => {
  const [movies, setMovies] = useState([]);
  const [categories, setCategories] = useState(["All"]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = active && active !== "All" ? { category: active } : {};
    api.get("/movies", { params })
      .then((r) => setMovies(r.data))
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <div className="min-h-screen bg-[#030303] pt-24 pb-20 px-4 sm:px-8 max-w-[1600px] mx-auto">
      <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tighter text-white mb-6">Browse Catalogue</h1>

      <div className="flex gap-2 overflow-x-auto rail pb-3 mb-8">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setActive(cat)}
            data-testid={`filter-${cat.toLowerCase()}`}
            className={`shrink-0 rounded-full px-5 py-2 text-sm font-medium border transition-colors ${
              active === cat
                ? "bg-[#00F0FF] text-black border-[#00F0FF]"
                : "bg-white/5 text-white/70 border-white/10 hover:border-white/30 hover:text-white"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="w-10 h-10 rounded-full border-2 border-white/10 border-t-[#00F0FF] animate-spin" />
        </div>
      ) : movies.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="browse-empty">
          <Film size={48} className="text-white/20 mb-4" />
          <p className="text-white/60">No titles match this filter yet.</p>
        </div>
      ) : (
        <div
          className="grid gap-4 sm:gap-6"
          style={{ gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))" }}
          data-testid="browse-grid"
        >
          {movies.map((m) => (
            <div key={m.id} className="w-full">
              <MovieCardFull movie={m} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Full-width variant so grid cells fill uniformly
const MovieCardFull = ({ movie }) => {
  const Card = MovieCard;
  return (
    <div className="[&>a]:!w-full">
      <Card movie={movie} testid={`browse-card-${movie.id}`} />
    </div>
  );
};

export default Browse;
